$(document).ready(function(){
	if ($('#map').length) {

		// -- init map --
		var lang = $('html').attr('lang');
		var year = window.location.pathname.split('/')[2];
		var interactiveMapId = $('meta[name=interactiveMapId]').attr("content");
		mapboxgl.accessToken = 'pk.eyJ1IjoiZXZlcnl0aGluZ2lzZnVuIiwiYSI6IkVkalZJRUkifQ.i_Taxju9f5wO9aUyOF7Gyg';
		var map = new mapboxgl.Map({
			container: 'map',
			style: 'mapbox://styles/everythingisfun/'+interactiveMapId,
			center: [20.703725, 34.487650],
			zoom: 1.47,
			minZoom: 1.4,
			maxZoom: 6,
			renderWorldCopies: false,
			maxBounds: [[-180, -85], [180, 85]]
		});

		// -- add zoom and rotation controls to the map --
		map.addControl(new mapboxgl.NavigationControl(), 'top-left');

		// -- load map --
		map.on('load', function() {

			// -- create popup without adding to map --
			var popup = new mapboxgl.Popup({offset: 15, closeOnClick: false});

			// -- add polygons countries --
			initPolygonLayer(map, 'partnersCountries', 'partners', '#60b237', popup, year);
			initPolygonLayer(map, 'projectsCountries', 'projects', '#df7d2f', popup, year);
			initPolygonLayer(map, 'suspendedCountries', 'suspended', '#efbd96', popup, year);
			
			// -- add regional cooperation --
			initPointLayer(map, 'getRegionalCooperation', 'cooperation', popup, year);

			// -- add humanitarian actions --
			initPointLayer(map, 'getHumanitarianActions', 'actions', popup, year);

			// -- add emergency --
			initPointLayer(map, 'getEmergency', 'emergency', popup, year);

		});


		// -- functions --

		var popupInner = function(data){
			var charsLimit = 125;
			return '<div class="wrapper"><img class="flag" src="' + data.flag + '"><div class="content"><h3 class="title">' + data.title + '</h3><p class="continent">' + data.continent + '</p></div></div>' + ((data.banner.length) ? '<div class="image"><img src="' + data.banner + '"></div>' : '') + ((data.legend.length) ? '<div class="text">' + ((data.legend.length > charsLimit) ? data.legend.substring(0, charsLimit) + ' (…)' : data.legend) + '</div>' : '') + '<a class="btn btn--outline--brand" href="' + data.link + '">' + data.linkTitle + '</a>';
		};


		var initPolygonLayer = function(map, layerName, layerType, color, popup, year){

			// -- add source --
			map.addSource(layerName, {
				type: 'geojson',
				data: '/'+lang+'/actions/geojson-module/default/build-geojson?type='+layerType+'&year='+year
			});

			// -- add layers --
			map.addLayer({
				id: layerName,
				source: layerName,
				type: 'fill',
				paint: {
					'fill-color': color
				},
			},'admin-1-boundary-bg');

			// -- add popup on click --
			map.on('click', layerName, function(e) {
				if (!e.originalEvent.target.classList.contains('icon-marker')) { // -- fix marker and polygon popup overlapping --
					var country = e.features[0].properties;
					popup.setLngLat(e.lngLat).setHTML(popupInner(country)).addTo(map);
				}
			});

			// -- add popup on hover --
			var lastFeatureId;
			map.on('mousemove', layerName, function(e) {				
				var features = map.queryRenderedFeatures(e.point);
				function isLayer(feature) { 
				  return feature.source === layerName;
				}
				var country = features.find(isLayer).properties;
				if (country.id !== lastFeatureId) {
					lastFeatureId = country.id;
					var coords = (country.coordinates.lng != 0 && country.coordinates.lat != 0) ? $.parseJSON(country.coordinates) : e.lngLat;
					popup.setLngLat(coords).setHTML(popupInner(country)).addTo(map);
					$('.mapboxgl-popup').addClass('type--hover');
				}
			});
			
			// -- change the cursor to a pointer --
			map.on('mouseenter', layerName, function(e) {
				map.getCanvas().style.cursor = 'pointer';
			});
			 
			map.on('mouseleave', layerName, function(e) {
				// -- change the cursor back --
				map.getCanvas().style.cursor = '';
				// -- remove popup on hover --
				if ($('.mapboxgl-popup').length && $('.mapboxgl-popup').hasClass('type--hover')) {				
					popup.remove();
					lastFeatureId = '';
				}
			});

		};


		
		var initPointLayer = function(map, layerName, layerType, popup, year){
			// -- add source --
			$.ajax({
				type: 'GET',
				url: '/'+lang+'/actions/geojson-module/default/build-geojson?type='+layerType+'&year='+year,
				dataType: 'json',
				async: false,
				success: function(response, statut){
					layerName = response;
				}
			});

			// -- add custom markers with popup --
			layerName.features.forEach(function(data) {
				var country = data.properties;
			  var el = document.createElement('div');
			  el.className = 'icon icon-marker icon--' + country.icon;
			  new mapboxgl.Marker(el)
			    .setLngLat(data.geometry.coordinates)
			    .addTo(map);
		    
		    // -- add popup on click --
				$(el).on('click', function(e) {
					popup.setLngLat(data.geometry.coordinates).setHTML(popupInner(country)).addTo(map);
				});

				// -- add popup on hover --
				$(el).on('mouseenter', function(e) {
					popup.setLngLat(data.geometry.coordinates).setHTML(popupInner(country)).addTo(map);
					$('.mapboxgl-popup').addClass('type--hover');
				});
	
				// -- remove popup on hover --
				$(el).on('mouseleave', function(e) {
					if ($('.mapboxgl-popup').length && $('.mapboxgl-popup').hasClass('type--hover')) {				
						popup.remove();
					}
				});
			});

		};


	}
});